export default __webpack_public_path__ + "static/NestorOsuna_Pres2017_LinkstoPress-a54ded32264caa28e0ef720c1786113f.pdf";